export class GoatClient{

    constructor(public baseUrl:string){ 
    }

    heatmapPayload:any = {
        "scenario_id_input":0,
        "pois":{},
        "heatmap_type":"heatmap_gravity",
        "modus_input":"default",
        "return_type":"geobuf"
    }

    isochronePayload:any = {
        "user_id": 266,
        "minutes": 15,
        "speed": 5,
        "n": 1,
        "modus": "default",
        "concavity": "0.00003",
        "routing_profile": "walking_standard",
        "scenario_id": 0
    }


    createIsochronePayload(coords:Array<number>, routing_profile:string, minutes:number, speed:number){
        
        this.isochronePayload.minutes = minutes
        this.isochronePayload.routing_profile = routing_profile
        this.isochronePayload.speed = speed

        this.isochronePayload.x = coords[0]
        this.isochronePayload.y = coords[1]

    }

    createHeatmapPayload(ids:Array<string>){
        
        for(let id of ids){

            this.heatmapPayload.pois[id] = {"sensitivity":300000,"weight":1}

        }
    }
    
    async requestIsochrone(){

        let response = await fetch(this.baseUrl+'/api/map/isochrone', {method: 'POST', 
                                                                        mode: 'cors',
                                                                        headers: {
                                                                                'Content-Type': 'application/json'
                                                                                // 'Content-Type': 'application/x-www-form-urlencoded',
                                                                                },                                 
                                                                        body:JSON.stringify(this.isochronePayload)})

        return await response.json()
    }

    async createHeatmap(ids:Array<string>){

        this.createHeatmapPayload(ids)
        
        await fetch(this.baseUrl+'/api/map/heatmap', {method: 'POST', 
                                    mode: 'cors',
                                    headers: {
                                            'Content-Type': 'application/json'
                                            // 'Content-Type': 'application/x-www-form-urlencoded',
                                            },                                 
                                    body:JSON.stringify(this.heatmapPayload)})
    }
    
}